import { c as _c } from "react/compiler-runtime";
import { FormSelect } from '@systemeio/ui';
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface';
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { TriggerDigitalStoreFormSubscribedEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import React from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { OpenInNewIcon } from '@systemeio/ui/icons';
interface TriggerDigitalStoreItemProps extends EditTriggerItemInterface<TriggerDigitalStoreFormSubscribedEditInterface> {}
const TriggerDigitalStoreItem = t0 => {
  const $ = _c(17);
  const {
    triggers,
    trigger,
    idx,
    onDelete,
    setRules,
    errors,
    isStatic
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== errors.automationTriggers || $[4] !== idx || $[5] !== isStatic || $[6] !== setRules || $[7] !== t || $[8] !== trigger.digitalStore || $[9] !== trigger.id || $[10] !== trigger.itemOptIn || $[11] !== triggers) {
    t2 = t3 => {
      const {
        renderTriggerLabel,
        data,
        onOpen
      } = t3;
      return <><FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.digital_store_form_subscribed)} label={renderTriggerLabel({
          label: t("dashboard.store.title"),
          additionalLabel: trigger.digitalStore.id ? <LinkWithoutPrefetch href={`/stores/${trigger.digitalStore.id}`} className="group self-center outline-hidden" target="_blank"><OpenInNewIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary" /></LinkWithoutPrefetch> : undefined
        })} placeholder={t("dashboard.automation_rule.choose_store")} value={trigger.digitalStore.id} staticData={getDataFromObj(trigger.digitalStore)} data={data.digitalStoresData} onChange={data_0 => {
          setRules(prev => ({
            ...prev,
            triggers: triggers.map((el, i) => {
              if (idx === i) {
                return {
                  ...el,
                  digitalStore: {
                    id: data_0
                  },
                  itemOptIn: {
                    id: undefined
                  }
                };
              } else {
                return el;
              }
            })
          }));
        }} error={errors.automationTriggers[trigger.id]?.digitalStoreId?.join("")} />{trigger.digitalStore.id && <FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.digital_store_form_subscribed)} label={renderTriggerLabel({
          label: t("dashboard.automation_rule.store_optin")
        })} placeholder={t("dashboard.automation_rule.choose_store_optin")} staticData={[{
          id: trigger.itemOptIn.id,
          caption: trigger.itemOptIn.title || ""
        }]} value={trigger.itemOptIn.id} data={data.digitalStoreOptInsData} onChange={data_1 => setRules(prev_0 => ({
          ...prev_0,
          triggers: triggers.map((el_0, i_0) => {
            if (idx === i_0) {
              return {
                ...el_0,
                itemOptIn: {
                  id: data_1
                }
              };
            } else {
              return el_0;
            }
          })
        }))} error={errors.automationTriggers[trigger.id]?.itemOptInId?.join("")} />}</>;
    };
    $[3] = errors.automationTriggers;
    $[4] = idx;
    $[5] = isStatic;
    $[6] = setRules;
    $[7] = t;
    $[8] = trigger.digitalStore;
    $[9] = trigger.id;
    $[10] = trigger.itemOptIn;
    $[11] = triggers;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== trigger) {
    t3 = <EditTriggerWrapper trigger={trigger} onDelete={t1}>{t2}</EditTriggerWrapper>;
    $[13] = t1;
    $[14] = t2;
    $[15] = trigger;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
};
export default TriggerDigitalStoreItem;